import moment from 'moment'

export const dateSince = (time) => {
  if (!time) { return "Never"}
  return moment(time).fromNow()
}

// QTH locator calculations based on https://github.com/jleh/qth-locator
// Credits to Juuso Lehtinen @ https://github.com/jleh
export const latLngToLocator = (lat, lng) => { 
  const CHAR_CODE_OFFSET = 65;
  const numberToChar = number => String.fromCharCode(number + CHAR_CODE_OFFSET);
  const longitude = lng + 180;
  const latitude = lat + 90;

  const fieldLng = numberToChar(Math.floor(longitude / 20));
  const fieldLat = numberToChar(Math.floor(latitude / 10));

  const squareLng = Math.floor(longitude % 20 / 2);
  const squareLat = Math.floor(latitude % 10);

  const subsquareLng = numberToChar(Math.floor((longitude % 20 % 2) * 12)).toLowerCase();
  const subsquareLat = numberToChar((latitude % 10 - squareLat) * 24).toLowerCase();

  return fieldLng + fieldLat + squareLng + squareLat + subsquareLng + subsquareLat;
}